/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */


var productCardMarkup = `
   {{#products}} 
   <a href="{{du}}" aria-label="{{dt}}" class="flex relative flex-col">
     <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="absolute right-0 top-0 z-[1] cursor-pointer">
       <span class="swym-icon">
			 	<svg aria-hidden="true" focusable="false" height="1em" preserveAspectRatio="xMidYMid meet" role="img" viewBox="0 0 20 17.364" width="1em" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="vertical-align: -0.125em;"><path d="M3.343,7.778a4.5,4.5,0,0,1,7.339-1.46L12,7.636l1.318-1.318a4.5,4.5,0,1,1,6.364,6.364L12,20.364,4.318,12.682a4.5,4.5,0,0,1-.975-4.9Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(-2 -4)"></path></svg>
       </span>
     </button>
     <div class="w-full px-spacing-md">
       <img alt="" class="object-contain aspect-1/1" src="{{iu}}">
     </div>
			<div class="mt-spacing-sm lg:px-spacing-xs pb-spacing-sm">
				<div class="text-base font-semibold font-body">
					{{dt}}
				</div>
			 <div class="swym-product-price swym-text swym-text-1">
				<div class="swym-product-final-price swym-value">
					{{cu}}{{pr}}
				</div>
			</div>
		 </div>
     <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="inline-block px-4 py-1.5 text-base font-semibold text-center border cursor-pointer hover:underline text-purple border-purple">
       {{#isInCart}}${window.wusthof_translations.addedToCart}{{/isInCart}}{{^isInCart}}${window.wusthof_translations.addToCart}{{/isInCart}}
     </button>
   </a>
   {{/products}}
`;

function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
	}, function(e) {
		console.log(e);
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		if(wishlistContentsContainer && formattedWishlistedProducts.length > 0){
			wishlistContentsContainer.innerHTML = productCardsMarkup;
			attachClickListeners();
		}
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */